<template>
  <section class="relative bg-lifeboost-orange-100 md:py-28 py-14">
    <div class="mx-auto max-w-desktop">
      <div class="max-w-screen-xl px-4 mx-auto space-y-8 md:space-y-14 sm:px-8 xl:px-0">
        <div class="mx-auto max-w-7xl">
          <h3 class="font-bold text-center text-white title-mushroom 2xl:px-28 md:px-0" v-html="titleText"></h3>
          <div class="grid grid-cols-12 mt-20 md:mt-28 gap-x-0 md:gap-x-6 md:gap-y-28 gap-y-20">
            <div class="flex flex-col items-center justify-center col-span-6 md:col-span-3 gap-y-4"
              v-for="(item, index) in items" :key="index">
              <div
                class="sm:h-24 sm:w-24 w-20 h-20 bg-[#773725] rounded-full border border-solid border-[#481D12] flex items-center justify-center">
                <nuxt-img :src="item.imgSrc" :alt="item.imgAlt"
                  :class="item.width ? item.width : ''" width="34" height="34" format="webp"
                  loading="lazy"></nuxt-img>
              </div>
              <div class="text-xl leading-none text-center text-white md-max:leading-8 font-ww-regular sm:text-28 text-25 md:text-26 lg:text-28" v-html="item.text">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="relative px-5 py-8 mx-auto mt-8 text-center sm:px-7 md:mt-24 max-w-desktop lg:px-10 md:px-8">
        <ClientOnly>
          <Swiper autoHeight :class="'relative overflow-hidden'"
            :autoplay="{ delay: 1500, disableOnInteraction: false, pauseOnMouseEnter: false }"
            :modules="[SwiperNavigation]" :slidesPerView="2" :spaceBetween="30" :loop="true" :rewind="true"
            :navigation="{
                nextEl: '.swiper-button-next-img',
                prevEl: '.swiper-button-prev-img'
            }" :breakpoints="{
                1900: { slidesPerView: 6 },
                1600: { slidesPerView: 5 },
                1200: { slidesPerView: 5 },
                1024: { slidesPerView: 5 },
                768: { slidesPerView: 4, spaceBetween: 25 },
                620: { slidesPerView: 2, spaceBetween: 25 },
                540: { slidesPerView: 2, spaceBetween: 25 },
                480: { slidesPerView: 2, spaceBetween: 10 },
                320: { spaceBetween: 10 },
            }">
            <SwiperSlide v-for="(testimonial, index) in testimonials" :key="index">
              <nuxt-img sizes="xs:150px sm:240px md:342px lg:223px xl:200px 2xl:250px"
                :src="testimonial.imgSrc" :alt="testimonial.imgAlt" class="object-contain w-full rounded-3xl" width="300"
                height="410" format="webp"></nuxt-img>
            </SwiperSlide>
          </Swiper>

          <div class="absolute inset-y-0 z-10 mx-0 my-auto md:left-4 left-3">
            <button aria-label="Go to previous slide" type="button"
              class="flex items-center justify-center h-full cursor-pointer swiper-button-prev-img group focus:outline-none">
              <span class="flex items-center justify-center bg-white rounded-full w-14 h-14 sm:w-16 sm:h-16">
                <svg class="" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28px"
                  height="24.5px" viewBox="0 0 38 31">
                  <path fill-rule="evenodd" fill="rgb(228, 132, 20)"
                    d="M0.577,17.013 L13.840,30.420 C14.611,31.199 15.861,31.200 16.631,30.422 C17.401,29.643 17.400,28.381 16.629,27.601 L6.817,17.683 L36.369,17.683 C37.270,17.683 38.001,16.944 38.001,16.033 L38.001,15.337 C38.001,14.426 37.270,13.687 36.369,13.687 L6.459,13.687 L16.638,3.398 C17.408,2.619 17.407,1.357 16.636,0.577 C15.865,-0.202 14.616,-0.203 13.846,0.575 L0.599,13.965 C0.257,14.311 0.076,14.753 0.038,15.206 C-0.088,15.839 0.091,16.522 0.577,17.013 Z" />
                </svg>
                <span class="sr-only">Previous</span>
              </span>
            </button>
          </div>
          <div class="absolute inset-y-0 z-20 mx-0 my-auto md:right-4 right-3">
            <button aria-label="Go to next slide" type="button"
              class="flex items-center justify-center h-full cursor-pointer group focus:outline-none swiper-button-next-img">
              <span class="flex items-center justify-center rotate-180 bg-white rounded-full w-14 h-14 sm:w-16 sm:h-16">
                <svg class="" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28px"
                  height="24.5px" viewBox="0 0 38 31">
                  <path fill-rule="evenodd" fill="rgb(228, 132, 20)"
                    d="M0.577,17.013 L13.840,30.420 C14.611,31.199 15.861,31.200 16.631,30.422 C17.401,29.643 17.400,28.381 16.629,27.601 L6.817,17.683 L36.369,17.683 C37.270,17.683 38.001,16.944 38.001,16.033 L38.001,15.337 C38.001,14.426 37.270,13.687 36.369,13.687 L6.459,13.687 L16.638,3.398 C17.408,2.619 17.407,1.357 16.636,0.577 C15.865,-0.202 14.616,-0.203 13.846,0.575 L0.599,13.965 C0.257,14.311 0.076,14.753 0.038,15.206 C-0.088,15.839 0.091,16.522 0.577,17.013 Z" />
                </svg>
                <span class="sr-only">Next</span>
              </span>
            </button>
          </div>
        </ClientOnly>
      </div>

      <!-- Button Section -->
      <div class="max-w-3xl px-6 mx-auto mt-10 text-center xl:max-w-5xl md:mt-14 md:px-0 lg:mb-6">
        <button @click="scrollTo(buttonLink, scrollPosition(mobilePosition))" class="flex items-center w-full bnt-icon md:w-auto">
          <span class="flex items-center" v-html="buttonText"></span>
          <svg class="relative ml-4 top-0.5 sm:w-auto w-8" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" width="38px" height="31px" viewBox="0 0 38 31">
            <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
              d="M37.423,17.013 L24.160,30.420 C23.389,31.199 22.139,31.200 21.369,30.422 C20.599,29.643 20.600,28.381 21.371,27.601 L31.183,17.683 L1.631,17.683 C0.730,17.683 -0.001,16.945 -0.001,16.033 L-0.001,15.338 C-0.001,14.426 0.730,13.688 1.631,13.688 L31.541,13.688 L21.362,3.398 C20.592,2.619 20.593,1.357 21.364,0.577 C22.135,-0.202 23.384,-0.203 24.154,0.575 L37.401,13.965 C37.743,14.311 37.924,14.754 37.962,15.206 C38.088,15.839 37.909,16.522 37.423,17.013 Z" />
          </svg>
        </button>

        <div class="relative flex flex-row justify-center pb-8 mt-5 md:mt-8">
          <div class="flex flex-col items-center justify-center 2xl:flex-row gap-x-3 md:gap-y-6 gap-y-3">
            <div class="py-4 pr-3 md:mb-0 md:py-0">
              <nuxt-img :src="starsImageSrc" :alt="starsImageAlt" class="" width="165" height="24" preload format="webp"></nuxt-img>
            </div>
            <div class="px-4 leading-8 text-white text-28 lg:text-30 xl:text-33 md:px-0">
              {{ cupsServedText }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Desktop and Mobile Bundles -->
    <nuxt-img :src="bundleDesktopSrc" :alt="bundleDesktopAlt" sizes="xs:150px sm:170px md:300px lg:477px xl:265px 2xl:320px"
      class="right-0 z-20 hidden xl:absolute -bottom-16 xl:block" width="494" height="519" format="webp" loading="lazy"></nuxt-img>

    <nuxt-img :src="bundleMobileSrc" :alt="bundleMobileAlt" sizes="xs:150px sm:170px md:300px lg:477px xl:265px 2xl:320px"
      class="right-0 z-20 px-8 mx-auto mt-8 -mb-48 xl:absolute -bottom-8 xl:hidden xl:mt-0 md:px-0" width="529"
      height="592" format="webp" loading="lazy"></nuxt-img>
  </section>
</template>

<script setup>
const props = defineProps({
  titleText: {
    type: String,
    default: "The Highest Quality High-Potency, Real Mushroom Extracts"
  },
  items: {
    type: Array,
    default: () => [
      {
        text: "100% Real <br> Mushrooms",
        imgSrc: '/assets/images/icon-mush-1.png',
        imgAlt: "Real Mushrooms Icon"
      },
      {
        text: "No Agricultural <br> Chemicals",
        imgSrc: '/assets/images/icon-mush-2.png',
        imgAlt: "No Agricultural Chemicals Icon"
      },
      {
        text: "Guaranteed <br> Potency",
        imgSrc: '/assets/images/icon-mush-3.png',
        imgAlt: "Guaranteed Potency Icon"
      },
      {
        text: "Guaranteed <br> Potency",
        imgSrc: '/assets/images/icon-mush-4.png',
        imgAlt: "Guaranteed Potency Icon"
      },
      {
        text: "Ultra-Purified <br> Water Filtered",
        imgSrc: '/assets/images/icon-mush-5.png',
        imgAlt: "Ultra-Purified Water Filtered Icon"
      },
      {
        text: "Tested for  <br> Contaminants",
        imgSrc: '/assets/images/icon-mush-6.png',
        imgAlt: "Tested for Contaminants Icon",
        width: "sm:w-9 w-7"
      },
      {
        text: "Tested for  <br> Heavy Metals",
        imgSrc: '/assets/images/icon-mush-7.png',
        imgAlt: "Tested for Heavy Metals Icon",
        width: "sm:w-8 w-6"
      },
      {
        text: "Analytically  <br> Verified",
        imgSrc: '/assets/images/icon-mush-8.png',
        imgAlt: "Analytically Verified Icon",
        width: "sm:w-8 w-6"
      },
    ]
  },
  testimonials: {
    type: Array,
    default: () => [
      {
        imgSrc: '/assets/images/mush-review-1.png',
        imgAlt: 'Mushroom Review 1'
      },
      {
        imgSrc: '/assets/images/mush-review-2.png',
        imgAlt: 'Mushroom Review 2'
      },
      {
        imgSrc: '/assets/images/mush-review-3.png',
        imgAlt: 'Mushroom Review 3'
      },
      {
        imgSrc: '/assets/images/mush-review-4.png',
        imgAlt: 'Mushroom Review 4'
      },
      {
        imgSrc: '/assets/images/revie1231.png',
        imgAlt: 'Mushroom Review 5'
      },
      {
        imgSrc: '/assets/images/mush-review-6.png',
        imgAlt: 'Mushroom Review 6'
      },
      {
        imgSrc: '/assets/images/mush-review-7.jpg',
        imgAlt: 'Mushroom Review 7'
      },
      {
        imgSrc: '/assets/images/mush-review-8.jpg',
        imgAlt: 'Mushroom Review 8'
      },
      {
        imgSrc: '/assets/images/mush-review-10.jpg',
        imgAlt: 'Mushroom Review 10'
      },
      {
        imgSrc: '/assets/images/mush-review-11.jpg',
        imgAlt: 'Mushroom Review 11'
      },
      {
        imgSrc: '/assets/images/mush-review-12.jpg',
        imgAlt: 'Mushroom Review 12'
      }
    ]
  },
  buttonText: {
    type: String,
    default: "Try it now!"
  },
  buttonLink: {
    type: String,
    default: "the-products"
  },
  starsImageSrc: {
    type: String,
    default: '/assets/images/Group-36.png'
  },
  starsImageAlt: {
    type: String,
    default: 'Rating Stars'
  },
  cupsServedText: {
  type: String,
  default: 'Over 60,000,000 Cups Served of Lifeboost Coffee'
},
  bundleDesktopSrc: {
    type: String,
    default: '/assets/images/bundle.png'
  },
  bundleDesktopAlt: {
    type: String,
    default: 'Product Bundle'
  },
  bundleMobileSrc: {
    type: String,
    default: '/assets/images/bundle-mobile.png'
  },
  bundleMobileAlt: {
    type: String,
    default: 'Product Bundle Mobile'
  },
  mobilePosition: {
        type: String,
        default: 'bottom'
    }
});

defineBuilderComponent({
  friendlyName: "Icons With Images Swiper",
  inputs: [
    {
      name: "titleText",
      type: "richText",
      friendlyName: "Section Title",
      defaultValue: "The Highest Quality High-Potency, Real Mushroom Extracts"
    },
    {
      name: "items",
      type: "list",
      friendlyName: "Items List",
      subFields: [
        {
          name: "text",
          type: "richText",
          friendlyName: "Item Text",
          defaultValue: ""
        },
        {
          name: "imgSrc",
          type: "file",
          friendlyName: "Item Image Source",
          allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
          defaultValue: ""
        },
        {
          name: "imgAlt",
          type: "text",
          friendlyName: "Item Image Alt Text",
          defaultValue: "Item Icon"
        },
        {
          name: "width",
          type: "text",
          friendlyName: "Image Width Class",
          defaultValue: ""
        }
      ],
      defaultValue: [
        {
          text: "100% Real <br> Mushrooms",
          imgSrc: '/assets/images/icon-mush-1.png',
          imgAlt: "Real Mushrooms Icon"
        },
        {
          text: "No Agricultural <br> Chemicals",
          imgSrc: '/assets/images/icon-mush-2.png',
          imgAlt: "No Agricultural Chemicals Icon"
        },
        {
          text: "Guaranteed <br> Potency",
          imgSrc: '/assets/images/icon-mush-3.png',
          imgAlt: "Guaranteed Potency Icon"
        },
        {
        text: "Guaranteed <br> Potency",
        imgSrc: '/assets/images/icon-mush-4.png',
        imgAlt: "Guaranteed Potency Icon"
      },
      {
        text: "Ultra-Purified <br> Water Filtered",
        imgSrc: '/assets/images/icon-mush-5.png',
        imgAlt: "Ultra-Purified Water Filtered Icon"
      },
      {
        text: "Tested for  <br> Contaminants",
        imgSrc: '/assets/images/icon-mush-6.png',
        imgAlt: "Tested for Contaminants Icon",
        width: "sm:w-9 w-7"
      },
      {
        text: "Tested for  <br> Heavy Metals",
        imgSrc: '/assets/images/icon-mush-7.png',
        imgAlt: "Tested for Heavy Metals Icon",
        width: "sm:w-8 w-6"
      },
      {
        text: "Analytically  <br> Verified",
        imgSrc: '/assets/images/icon-mush-8.png',
        imgAlt: "Analytically Verified Icon",
        width: "sm:w-8 w-6"
      }
    ]
  },
  {
    name: "testimonials",
    type: "list",
    friendlyName: "Testimonials List",
    subFields: [
      {
        name: "imgSrc",
        type: "file",
        friendlyName: "Testimonial Image Source",
        allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
        defaultValue: ""
      },
      {
        name: "imgAlt",
        type: "text",
        friendlyName: "Testimonial Image Alt Text",
        defaultValue: "Testimonial Image"
      }
    ],
    defaultValue: [
      {
        imgSrc: '/assets/images/mush-review-1.png',
        imgAlt: 'Mushroom Review 1'
      },
      {
        imgSrc: '/assets/images/mush-review-2.png',
        imgAlt: 'Mushroom Review 2'
      },
      {
        imgSrc: '/assets/images/mush-review-3.png',
        imgAlt: 'Mushroom Review 3'
      },
      {
        imgSrc: '/assets/images/revie1231.png',
        imgAlt: 'Mushroom Review 4'
      },
      {
        imgSrc: '/assets/images/mush-review-5.png',
        imgAlt: 'Mushroom Review 5'
      },
      {
        imgSrc: '/assets/images/mush-review-6.png',
        imgAlt: 'Mushroom Review 6'
      },
      {
        imgSrc: '/assets/images/mush-review-7.jpg',
        imgAlt: 'Mushroom Review 7'
      },
      {
        imgSrc: '/assets/images/mush-review-8.jpg',
        imgAlt: 'Mushroom Review 8'
      },
      {
        imgSrc: '/assets/images/mush-review-10.jpg',
        imgAlt: 'Mushroom Review 10'
      },
      {
        imgSrc: '/assets/images/mush-review-11.jpg',
        imgAlt: 'Mushroom Review 11'
      },
      {
        imgSrc: '/assets/images/mush-review-12.jpg',
        imgAlt: 'Mushroom Review 12'
      }
    ]
  },
  {
    name: "buttonText",
    type: "richText",
    friendlyName: "Button Text",
    defaultValue: "Try it now!"
  },
  {
    name: "buttonLink",
    type: "url",
    friendlyName: "Button Link",
    defaultValue: "the-products"
  },
  {
            name: 'mobilePosition',
            type: 'enum',
            friendlyName: 'Scroll Position mobile',
            enum: [
                { label: 'Bottom', value: 'bottom' },
                { label: 'Top', value: 'top' }
            ],
            defaultValue: 'Bottom'
  },
  {
    name: "starsImageSrc",
    type: "file",
    friendlyName: "Stars Image Source",
    allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
    defaultValue: "/assets/images/Group-36.png"
  },
  {
    name: "starsImageAlt",
    type: "text",
    friendlyName: "Stars Image Alt Text",
    defaultValue: "Rating Stars"
  },
  {
    name: "cupsServedText",
    type: "richText",
    friendlyName: "Cups Served Text",
    defaultValue: "Over 60,000,000 Cups Served of Lifeboost Coffee"
  },
  {
    name: "bundleDesktopSrc",
    type: "file",
    friendlyName: "Desktop Bundle Image Source",
    allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
    defaultValue: "/assets/images/bundle.png"
  },
  {
    name: "bundleDesktopAlt",
    type: "text",
    friendlyName: "Desktop Bundle Image Alt Text",
    defaultValue: "Product Bundle"
  },
  {
    name: "bundleMobileSrc",
    type: "file",
    friendlyName: "Mobile Bundle Image Source",
    allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
    defaultValue: "/assets/images/bundle-mobile.png"
  },
  {
    name: "bundleMobileAlt",
    type: "text",
    friendlyName: "Mobile Bundle Image Alt Text",
    defaultValue: "Product Bundle Mobile"
  }
]
});
</script>
